import React from 'react';
import { Chip } from '@material-ui/core';
import { CategoryStatuses } from 'pages/categories/enums/category-statuses.enum';

interface IGetCategoryStatusStyle {
  color: string;
  backgroundColor: string;
}

const getCategoryStatusStyle: Record<
  CategoryStatuses,
  IGetCategoryStatusStyle
> = {
  [CategoryStatuses.ErrorWhenTranslating]: {
    backgroundColor: '#572A3F',
    color: '#d5a6bdff',
  },
  [CategoryStatuses.InTranslation]: {
    backgroundColor: '#60705A',
    color: '#A4FF80',
  },
  [CategoryStatuses.WaitingForTranslation]: {
    backgroundColor: '#73733C',
    color: '#f2f2c7ff',
  },
  [CategoryStatuses.Translated]: {
    color: '#687065',
    backgroundColor: '#dff0d8ff',
  },
};

const statusChip = (status: string, id: CategoryStatuses) => (
  <Chip
    label={status}
    style={{ ...getCategoryStatusStyle[id], ...{ maxWidth: '150px' } }}
  />
);

export const labelCategoryStatuses: Record<CategoryStatuses, JSX.Element> = {
  [CategoryStatuses.ErrorWhenTranslating]: statusChip(
    'Error when translating',
    CategoryStatuses.ErrorWhenTranslating,
  ),
  [CategoryStatuses.InTranslation]: statusChip(
    'In translation',
    CategoryStatuses.InTranslation,
  ),
  [CategoryStatuses.WaitingForTranslation]: statusChip(
    'Waiting for translation',
    CategoryStatuses.WaitingForTranslation,
  ),
  [CategoryStatuses.Translated]: statusChip(
    'Translated',
    CategoryStatuses.Translated,
  ),
};
